<template>
  <v-dialog v-model="dialogExport" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title> Xuất kho  {{currentTime | display_date('DD-MM-YYYY')}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg7 md7 sm7>
            <v-layout row wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-autocomplete label="Chọn khách hàng" v-model="selectedUID" :items="customers" :item-text="getCustomerText" item-value="ID"></v-autocomplete>
                </v-flex>
                <v-flex lg4 md4 sm12 pa-0 ma-0>
                    <v-checkbox label="Xuất theo lô hàng" v-model="exportByBigPackage" :disabled="selectedUID == 0"></v-checkbox>
                </v-flex>
                <v-flex lg4 md4 sm12 pa-0 ma-0>
                    <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader" :disabled="selectedUID == 0"></v-checkbox>
                </v-flex>
                <v-flex lg4 md4 sm12 pa-0 ma-0>
                    <v-checkbox label="Xuất tất cả" v-model="exportAll" :disabled="selectedUID == 0" v-if="adminRole || paymentRole"></v-checkbox>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 v-if="!exportByBigPackage">
                  <v-autocomplete v-if="!useBarcodeReader" label="Mã vận đơn" ref="trancode" :items="suggestListObj" item-text="TransactionCode" item-value="TransactionCode"  v-model="currentTransaction.TransactionCode" :search-input.sync="search" class="input-group--focused" @change="manualChanged"></v-autocomplete>
                    <v-text-field
                    v-else
                    label="Mã vận đơn"
                    ref="trancode"
                    v-model="currentTransaction.TransactionCode"
                    class="input-group--focused"
                    @input="codeChanged"
                    @keyup.enter="manualChanged"
                    :disabled="selectedUID == 0"
                    ></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 v-else>
                  <v-autocomplete label="Mã lô hàng" ref="trancode" :items="bigSuggestListObj" item-text="PackageCode" item-value="PackageCode"  v-model="selectedPackageCode" :search-input.sync="search" class="input-group--focused" @change="bigManualChanged">
                    <template slot="no-data">
                      <span>
                        <p class="pt-2">Không có dữ liệu</p>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 v-if="!exportByBigPackage">
                    <v-data-table
                    :headers="headers"
                    :items="Packages"
                    :must-sort="true"
                    :mobile-breakpoint="100"
                    disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:item="{ item, index }">
                        <tr>
                        <td>{{ item.TransactionCode }}</td>
                        <td class="text-center">
                            <v-icon small @click="deleteTransaction(index)">fa-trash-alt</v-icon>
                        </td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0 v-else>
                    <v-data-table
                    :headers="big_headers"
                    :items="BigPackages"
                    :must-sort="true"
                    :mobile-breakpoint="100"
                    disable-pagination
                    hide-default-footer
                    >
                    <template v-slot:item="{ item, index }">
                        <tr>
                        <td>{{ item.PackageCode }}</td>
                        <td class="text-center">
                            <v-icon small @click="deleteBigPackage(index)">fa-trash-alt</v-icon>
                        </td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg5 md5 sm5 pl-3 pr-2 pt-4>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap pl-5>
                <h-currency-input
                  label="Số lượng"
                  v-model="Packages.length"
                  :decimal="0"
                  readonly
                  class="input-group--focused"
                  v-if="!exportByBigPackage"
                ></h-currency-input>
                <h-currency-input
                  label="Số lượng"
                  v-model="BigPackages.length"
                  :decimal="0"
                  readonly
                  class="input-group--focused"
                  v-else
                ></h-currency-input>
                <!-- <v-flex lg12 md12 sm12 pa-0>
                  <v-text-field
                    label="Khách hàng"
                    v-model="CustomerName"
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex> -->
                <v-flex lg12 md12 sm12 pa-0 pt-3>
                  <v-autocomplete label="Địa chỉ nhận" v-model="addressID" :items="addressBooks" :item-text="getAddressText" item-value="ID" @change="onSelectedAddress"></v-autocomplete>
                </v-flex>
                <!-- <v-flex lg12 md12 sm12 pa-0 pt-3>
                  <v-text-field
                    label="Điện thoại"
                    v-model="PhoneNumber"
                    class="input-group--focused"
                  ></v-text-field>
                </v-flex> -->
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1 white--text" @click="printItem">Lưu phiếu</v-btn>
        <!-- <v-btn color="red darken-1 white--text" @click="saveItem">Xuất kho</v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import configs from "@/configs";
import Vue from 'vue';
import _ from "lodash";
import { mapState } from "vuex";
import { getCurrentTime, sendErrorNotice, playSound } from "@/commons/utils";
import { request_list, print_export_receipt_order_v1 } from '@/commons/hpod';
export default {
  name: "export_popup",
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 5;
    return {
      selectedUID: 0,
      addressID: 0,
      valid: true,
      useBarcodeReader: false,
      exportByBigPackage: false,
      autoPackageCode: configs.SYSTEM_CONFIG.auto_pack_code,
      currentTransaction: {
        TransactionCode: ""
      },
      selectedPackageCode: "",
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      big_headers: [
        {
          text: "Mã lô",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      PackageCodeRules: [v => (!this.autoPackageCode && !!v) || "Mã lô không được để trống."],
      currentTime: getCurrentTime(),
      Packages: [],
      BigPackages: [],
      CustomerName: '',
      Address: '',
      PhoneNumber: '',
      queryTerm: '',
      exportAll: false,

    };
  },
  props: ["dialogExport"],
  watch: {
    useBarcodeReader() {
      if (this.useBarcodeReader) {
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    dialogExport() {
        if(this.dialogExport) {
            this.Packages = [];
            this.selectedUID = 0;
            this.Address = '';
        }
    },
    selectedUID() {
      this.getSuggestList();
    },
    exportByBigPackage() {
      this.getSuggestList();
    },
    exportAll() {
      if(this.exportAll) {
        this.Packages = this.suggestList;
      }
      else {
        this.Packages = [];
      }
    },
    addressBooks() {
      if(this.addressBooks && this.addressBooks.length > 0) {
        this.addressID = this.addressBooks[0].ID;
      }
    }
  },
  computed: {
    ...mapState({
        customers: state => state.deliverable.customers.data,
        suggestList: state => state.orderTransaction.suggestList.data,
        bigSuggestList: state => state.bigPackage.suggestList.data,
        addressBooks: state => state.addressBook.all.data,
    }),
    search: {
      get () {
        return this.queryTerm
      },
      set (searchInput) {
        if (this.queryTerm !== searchInput) {
          this.queryTerm = searchInput;
        }
      }
    },
    suggestListObj() {
      return _.filter(this.suggestList, (p) => {return !_.find(this.Packages, {'TransactionCode': p.TransactionCode})})
    },
    bigSuggestListObj() {
      return _.filter(this.bigSuggestList, (p) => {return !_.find(this.BigPackages, {'PackageCode': p.PackageCode})})
    },
    adminRole() {
        return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    paymentRole() {
        return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
  },
  methods: {
    getSuggestList() {
      if(this.selectedUID>0) {
        if(!this.exportByBigPackage) {
          this.$store.dispatch("orderTransaction/getListSuggest", {
            filter: [{
              column: "Status",
              value: 4,
              condition: "equal",
            },
            {
              column: "RequestID",
              value: 0,
              condition: "equal",
            },
            {
              column: "UID",
              value: this.selectedUID,
              condition: "equal",
            }]
          });
        }
        else {
          this.$store.dispatch("bigPackage/getListSuggest", {
            filter: [{
              column: "Status",
              value: 1,
              condition: "equal",
            },
            {
              column: "State",
              value: 2,
              condition: "equal",
            },
            {
              column: "PackageCode",
              value: `DL${this.selectedUID}-`,
              condition: "contain",
            }]
          });
        }
      }
      this.Packages=[];
      this.$store.dispatch("addressBook/getList", {
        filter: [{
          column: "UID",
          value: this.selectedUID,
          condition: "equal"
        }]
      });
    },
    closePopup() {
      this.$emit("closePopup");
    },
    deleteTransaction(index) {
      this.Packages.splice(index, 1);
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    deleteBigPackage(index) {
      this.BigPackages.splice(index, 1);
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    printItem() {
      if(!this.addressID) {
        sendErrorNotice('Hãy chọn địa chỉ khách hàng');
        return;
      }
      this.onSelectedAddress();
      
      // Tạo payment request thông qua API
      const requestData = {
        UID: this.selectedUID,
        Username: this.CustomerName,
        ReceiverName: this.CustomerName,
        ReceiverPhone: this.PhoneNumber,
        ReceiverAddress: this.Address,
        PackageIDs: _.map(this.Packages, "ID")
      };

      if(this.exportByBigPackage) {
        this.$store.dispatch("orderTransaction/getList", {filter: [
            { column: "BigPackageID", value: _.map(this.BigPackages, "ID"), condition: "in" },
            { column: "Status", value: 4, condition: "equal" },
            { column: "UID", value: this.selectedUID, condition: "equal" }]}).then(p => { 
              requestData.PackageIDs = _.map(p.data, "ID");
              this.$store.dispatch("paymentRequest/createFromPackages", requestData).then( p => {
                this.$router.push({
                      name: "PaymentRequestDetail",
                      params: {
                      Pid: p.data.ID,
                      title: `Chi tiết yêu cầu giao hàng (#${p.data.ID})`,
                      },
                      query: { 'is_print': 1 }
                  });
              });
            })
      }
      else {
        this.$store.dispatch("paymentRequest/createFromPackages", requestData).then( p => {
          this.$router.push({
                name: "PaymentRequestDetail",
                params: {
                Pid: p.data.ID,
                title: `Chi tiết yêu cầu giao hàng (#${p.data.ID})`
                },
                query: { 'is_print': 1 }
            });
        });
      }
    },
    saveItem() {
      if(!this.exportByBigPackage) {
        this.$store.dispatch("orderTransaction/updateMultiple", {
          TransactionIDs: _.map(this.Packages, "ID"),
          Status: 5,
          ModifiedBy: this.$store.state.authentication.user.username,
        });
      }
      else {
        this.$store.dispatch("bigPackage/updateMultiple", {
          BigPackageIDs: _.map(this.BigPackages, "ID"),
          Action: 'export',
          Deliverable: 1,
          UID: this.selectedUID,
          ModifiedBy: this.$store.state.authentication.user.username,
        });
      }
    },
    getCustomerText(item) {
      return `DL${item.ID} - ${item.Username} (${item.TotalPackage} mã)`
    },
    getAddressText(item) {
      return `${item.Receiver} - ${item.Phone}`
    },
    manualChanged() {
      this.$refs.form.validate();
      this.currentTransaction.TransactionCode = this.currentTransaction.TransactionCode == '' ? this.queryTerm : this.currentTransaction.TransactionCode;
      if (this.currentTransaction.TransactionCode !== "" && !this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    bigManualChanged() {
      this.$refs.form.validate();
      this.selectedPackageCode = this.selectedPackageCode == '' ? this.queryTerm : this.selectedPackageCode;
      if (this.selectedPackageCode !== "") {
        this.appendPackageCode();
      }
    },
    codeChanged() {
      this.$refs.form.validate();
      if (this.currentTransaction.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    appendTransactionCode: _.debounce(
      function() {
        var param = {
            filter: [{
                column: "TransactionCode",
                value: this.currentTransaction.TransactionCode.trim(),
                condition: "s_equal"
            },
            {
                column: "Status",
                value: 4,
                condition: "equal"
            }]
        };
        const checkTran = _.find(this.Packages, (p) => {return p.TransactionCode.toLowerCase().trim() == this.currentTransaction.TransactionCode.toLowerCase().trim()})
        if(checkTran) {
          this.currentTransaction = {
            TransactionCode: ""
          };
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Mã vận đơn đã tồn tại trong phiếu.')
          playSound('trung.mp3')
          return;
        }
        request_list('order_transactions', ret => {
          if(ret.data.length > 0) {
            if(ret.data[0].UID != this.selectedUID) {
                sendErrorNotice('Mã vận đơn không phải của khách hàng đã chọn.');
                playSound('khong-co-voice.mp3')
                return;
            }
            // if(!ret.data[0].Deliverable) {
            //     sendErrorNotice('Đơn hàng chưa tất toán.');
            //     playSound('chua-tat-toan-voice.mp3');
            //     return;
            // }
            
            this.Packages.unshift(ret.data[0]);
            if(ret.data[0].ShippingInfo) {
              this.Address = ret.data[0].ShippingInfo;
            }
            this.currentTransaction = {
              TransactionCode: ""
            };
            this.$nextTick(() => this.$refs.trancode.focus());
            playSound('co-voice.mp3');
          }
          else {
            sendErrorNotice('Mã vận đơn chưa nhập kho.')
            playSound('khong-co-voice.mp3')
          }
        }, Vue.http, param, this.$store.state.authentication.token);
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
    appendPackageCode: _.debounce(
      function() {
        const checkTran = _.find(this.BigPackages, (p) => {return p.PackageCode.toLowerCase().trim() == this.selectedPackageCode.toLowerCase().trim()});
        if(checkTran) {
          this.selectedPackageCode = "";
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Mã lô đã tồn tại trong phiếu.')
          playSound('trung.mp3')
          return;
        }
        const selectedTran = _.find(this.bigSuggestListObj, (p) => {return p.PackageCode.toLowerCase().trim() == this.selectedPackageCode.toLowerCase().trim()});
        this.BigPackages.unshift(selectedTran);
        this.selectedPackageCode = "";
        playSound('co-voice.mp3');
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
    onSelectedAddress() {
      const addr = _.find(this.addressBooks, {'ID': this.addressID});
      if(addr) {
          this.CustomerName = addr.Receiver;
          this.PhoneNumber = addr.Phone;
          this.Address = addr.Address;
      }
    }
  }
};
</script>